// src/utils/permissionUtils.js

export const validatePermission = (path, permissions, mapping) => {
    const requiredPermission = Object.keys(mapping).find(
      (key) => mapping[key] === path
    );
    return requiredPermission
      ? permissions.includes(parseInt(requiredPermission, 10))
      : false;
  };